<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelect"
  >
    <template slot="select-header">
      <div class="select-header-inner">
        <span class="title">{{ curPayType.name }}</span>
        <span
          v-if="showDeleteIco"
          @click="save"
          class="edit-btn j-save-card-btn"
          href="javascript:;"
          >{{ letter.save }}</span
        >
        <span
          v-else
          @click="edit"
          class="edit-btn j-edit-card-btn"
          href="javascript:;"
          >{{ letter.edit }}</span
        >
      </div>
    </template>
    <template slot="select-content">
      <ul class="card-select-container j-card-select-container">
        <li
          class="select-items-popup"
          :class="{ active: card.KEY_VALUE == curCard.KEY_VALUE }"
          pointClass="j-select-card"
          @click="selectCard(card)"
          v-for="card in cardInfos"
          :key="card.KEY_VALUE"
        >
          {{ card.KEY_VALUE_DESC }}
          <div v-if="showDeleteIco" @click.stop="deleteCard(card.KEY_VALUE)">
            <Icon class="delete-ico j-delete-card-btn" name="reduce-one"></Icon>
          </div>
        </li>
        <li
          class="select-items-popup"
          pointClass="j-select-new-card"
          :class="{ active: !curCard.KEY_VALUE }"
          @click="useNewCard"
        >
          {{ letter.quickcard_use_new_card }}
          <Icon class="new-ico j-new-card-btn" name="plus"></Icon>
        </li>
      </ul>
    </template>
  </SelectContianer>
</template>
<script>
import selectContainer from '@mixins/officialTopupNew/selectContainer';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV35';
export default {
  name: 'QuickPayCardSelecter',
  mixins: [selectContainer],
  data() {
    return {
      showDeleteIco: false,
      confirmDelete: false
    };
  },
  props: ['curPayType', 'cardInfos', 'curCard'],
  methods: {
    selectCard(card) {
      clickButton({
        btnName: 'select_creditcard',
        locationKey: locationType.paytypeSection
      });
      this.$emit('selectCard', card);
    },
    edit() {
      this.showDeleteIco = true;
    },
    save() {
      this.showDeleteIco = false;
    },
    deleteCard(keyValue) {
      clickButton({
        btnName: 'delete_creditcard',
        locationKey: locationType.paytypeSection
      });
      this.$emit('deleteCard', keyValue);
    },
    useNewCard() {
      clickButton({
        btnName: 'add_new_creditcard',
        locationKey: locationType.paytypeSection
      });
      this.$emit('selectCard', {});
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';
.select-header-inner {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  .title {
    font-size: 22px;
    font-weight: bold;
  }
}
.edit-btn {
  line-height: 1.2;
  text-align: center;
  font-size: 24px;
  color: #333333;
  padding: 5px 30px;
  border-radius: 40px;
  @include g-border();
}
.select-items-popup {
  display: flex;
  justify-content: space-between;
  font-size: 26px;
  .delete-ico {
    float: right;
    display: inline-block;
    width: 29px;
    height: 29px;
  }
  .new-ico {
    float: right;
    display: inline-block;
    width: 33px;
    height: 33px;
  }
}
</style>
